export const ARTIST_NAME = "ANDREA KIM BERTONE";
export const ARTIST_TAGLINE = "COMPOSER \u2022 SOUND DESIGNER";
export const ARTIST_EMAIL = "andrea.kim.bertone1@gmail.com";

export const ALBUM_TITLE = "Unknown Frequencies Parallel Galaxy Universe";
export const SPOTIFY_ALBUM_URL = "https://open.spotify.com/album/5GPbbs6T44TynBm03blS30";
export const SPOTIFY_EMBED_URL =
  "https://open.spotify.com/embed/album/5GPbbs6T44TynBm03blS30?utm_source=oembed";

export const IMAGES = {
  heroCover:
    "https://images.unsplash.com/photo-1636116524330-e1b72e090f48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxtb2R1bGFyJTIwc3ludGhlc2l6ZXIlMjBwYXRjaCUyMGNhYmxlc3xlbnwwfHx8fDE3OTIwMTIxOTh8MA&ixlib=rb-4.1.0&q=85",
  portfolio1:
    "https://images.unsplash.com/photo-1599060052009-24d6d0b0161c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxuZW9uJTIwYWxsZXklMjBtaXN0eXxlbnwwfHx8fDE3OTIwMTIxOTh8MA&ixlib=rb-4.1.0&q=85",
  portfolio2:
    "https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdsYXNzfGVufDB8fHx8MTc5MjAxMjE5OHww&ixlib=rb-4.1.0&q=85",
  portfolio3:
    "https://images.unsplash.com/photo-1544502062-f82887f03d1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBzaWxob3VldHRlfGVufDB8fHx8MTc5MjAxMjE5OHww&ixlib=rb-4.1.0&q=85",
  methodFrame:
    "https://images.unsplash.com/photo-1741746239350-9021ddfa3d59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtdXNpYyUyMHN0dWRpbyUyMHdvcmtzdGF0aW9ufGVufDB8fHx8MTc5MjAxMjE5OHww&ixlib=rb-4.1.0&q=85",
};
